import {
  Box,
  Button,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Slider,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useClickAway } from "react-use";
import { Scrollbar } from "react-scrollbars-custom";
import { themedElement } from "@qpr/client-api-base/viewcomponents/utils";
import { ICardElementWithChildren } from "backend/model/model";
import Slide from "@material-ui/core/Slide";
import ClearIcon from "@material-ui/icons/Clear";
import ClearAllIcon from "@material-ui/icons/ClearAll";

const KPIDrawer = {
  Position: themedElement("KPIDetailsContent.KPIDrawer.Position", Box),
  Container: themedElement("KPIDetailsContent.KPIDrawer.Container", Paper),
  Heading: themedElement("KPIDetailsContent.KPIDrawer.Heading", Box),
  HeadingIcon: themedElement("KPIDetailsContent.KPIDrawer.HeadingIcon", Box),
  HeadingText: themedElement("KPIDetailsContent.KPIDrawer.HeadingText", Box),
  HeadingTotals: themedElement(
    "KPIDetailsContent.KPIDrawer.HeadingTotals",
    Box
  ),
  KPIRowMenu: themedElement("KPIDetailsContent.KPIDrawer.KPIRowMenu", MenuList),
  KPIRow: themedElement("KPIDetailsContent.KPIDrawer.KPIRow", MenuItem),
  KPIRowText: themedElement("KPIDetailsContent.KPIDrawer.KPIRowText", Box),
  Slider: themedElement("KPIDetailsContent.KPIDrawer.Slider", Slider),
  HandleContainer: themedElement(
    "KPIDetailsContent.KPIDrawer.HandleContainer",
    Button
  ),
  HandleCloseContainer: themedElement(
    "KPIDetailsContent.KPIDrawer.HandleCloseContainer",
    Button
  ),
  HandleIcon: themedElement("KPIDetailsContent.KPIDrawer.HandleIcon", Box),
  DrawerArea: themedElement("KPIDetailsContent.KPIDrawer.DrawerArea", Box),
};

const DrawerMenu = (props: {
  items: ICardElementWithChildren[];
  hide: boolean;
  onClose: () => void;
  onSelect?: (item: ICardElementWithChildren) => void;
  title?: string;
  animation?: string;
  selectedItem?: ICardElementWithChildren;
}) => {
  const ref = React.useRef(null);
  const { t } = useTranslation();
  useClickAway(ref, () => {
    props.onClose();
  });

  return (
    <KPIDrawer.Container
      className={`${props.animation}`}
      ref={ref}
      style={{
        visibility: props.hide ? "hidden" : "visible",
      }}
    >
      <KPIDrawer.HandleCloseContainer onClick={props.onClose}>
        <ClearIcon
          style={{
            color: "white",
            width: "36px",
            height: "36px",
            transform: "rotateX(-180deg)",
          }}
        />
      </KPIDrawer.HandleCloseContainer>
      <KPIDrawer.Heading>
        <KPIDrawer.HeadingText className="headingText">
          {" "}
          {props.title || t("KPIs")}
        </KPIDrawer.HeadingText>
        <KPIDrawer.HeadingTotals className="headingTotal">
          {`${props.items.length} ${t("Total")}`}
        </KPIDrawer.HeadingTotals>
      </KPIDrawer.Heading>

      <KPIDrawer.KPIRowMenu className="noscrollbars" autoFocus variant="menu">
        <Scrollbar
          style={{
            width: "300px",
            height: "334px",
          }}
        >
          {props.items.map((item) => {
            return (
              <KPIDrawer.KPIRow
                key={item.id}
                selected={item.id === props.selectedItem?.id}
                //              selected={i === index}
                onClick={() => {
                  if (props.onSelect) {
                    props.onSelect(item);
                  }
                  props.onClose();
                }}
              >
                <KPIDrawer.KPIRowText>{item.name}</KPIDrawer.KPIRowText>
              </KPIDrawer.KPIRow>
            );
          })}
        </Scrollbar>
      </KPIDrawer.KPIRowMenu>
    </KPIDrawer.Container>
  );
};

const ItemDrawer = (props: {
  title?: string;
  items?: ICardElementWithChildren[];
  selectedItem?: ICardElementWithChildren;
  onSelect?: (item: ICardElementWithChildren) => void;
  rtl?: boolean;
}) => {
  const [showMenu, setShowMenu] = React.useState(false);
  const [hasClosed, setHasClosed] = React.useState(false);

  const { rtl, items, title, selectedItem } = props;
  const [animation, setAnimation] = React.useState(
    rtl ? "leftMenuInFromLeft" : "leftMenuInFromRight"
  );

  React.useEffect(() => {
    if (showMenu) {
      setHasClosed(false);
    }
  }, [showMenu]);

  React.useEffect(() => {
    setShowMenu(false);
    setHasClosed(true);
    setAnimation("");
  }, [rtl]);

  if (!items) {
    return null;
  }
  return (
    <KPIDrawer.Position>
      <Slide
        direction={props.rtl ? "left" : "right"}
        in={showMenu}
        mountOnEnter
        unmountOnExit
        timeout={300}
      >
        <div
          style={{
            position: "relative",
            left: "0px",
            top: "-200px",
            marginLeft: "-20px",
            opacity: 1,
            zIndex: 3000,
          }}
        >
          <DrawerMenu
            items={items}
            key={`${animation}-${rtl ? "rtl" : "ltr"}`}
            title={title}
            hide={false}
            selectedItem={selectedItem}
            animation={""}
            onSelect={props.onSelect}
            onClose={() => {
              if (hasClosed) {
                return;
              }
              //setAnimation(rtl ? "leftMenuOutToRight" : "leftMenuOutToLeft");
              //setHasClosed(true);
              setShowMenu(false);
            }}
          />
        </div>
      </Slide>

      <KPIDrawer.HandleContainer
        onClick={() => {
          if (!showMenu) {
            setShowMenu(true);
          }
          setHasClosed(false);
          setAnimation(rtl ? "leftMenuInFromLeft" : "leftMenuInFromRight");
        }}
      >
        <ClearAllIcon
          style={{
            width: "36px",
            height: "36px",
            transform: "rotateX(-180deg)",
          }}
        />
      </KPIDrawer.HandleContainer>
    </KPIDrawer.Position>
  );
};

export default ItemDrawer;
